rkcApp.factory('Prognosis', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/articleprognosis/:subdir', {}, {
        distributionKeyForecasts: {method: 'POST', params: {subdir: 'distributionkeyforecasts'}}, //articleprognosis/distributionkeyforecasts
        forecast: {method: 'POST', params: {subdir: 'forecast'}}, //articleprognosis/forecast
        getForecastsPerDay: {method: 'GET', params: {subdir: 'forecastsperday'}}, //articleprognosis/forecastsperday
        postForecastsPerDay: {method: 'POST', params: {subdir: 'forecastsperday'}}, //articleprognosis/forecastsperday
        get: {method: 'GET', params: {subdir: 'get'}}, //articleprognosis/get
        getNote: {method: 'GET', isArray: true, params: {subdir: 'note'}}, //articleprognosis/note
        postNote: {method: 'POST', params: {subdir: 'note'}}, //articleprognosis/note
        getNotes: {method: 'GET', isArray: true, params: {subdir: 'notes'}}, //articleprognosis/notes
        search: {method: 'GET', params: {subdir: 'search'}}, //articleprognosis/search
        searchNotReceived: {method: 'GET', params: {subdir: 'searchnotreceived'}}, //articleprognosis/searchnotreceived
    })
}]);
rkcApp.factory('ForecastHistory', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/articleprognosis/forecasthistory/:lineId/:month', {}, {
        getForecastHistory: {method: 'GET', isArray: true}, //articleprognosis/forecastHistory/{lineId}/{month}
    })
}]);
rkcApp.factory('Parameters', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/parameters/:code', {}, {
        getParameters: {method: 'GET', isArray: true}, //parameters/
        updateParameter: {method: 'PATCH'}, //parameters/
    })
}]);
rkcApp.factory('DistributionKeys', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/distributionkeys/:val', {}, {
        getDistributionKeys: {method: 'GET', isArray: true}, //distributionkeys/
        postDistributionKeys: {method: 'POST'}, //distributionkeys/
        distributionKeysForArticle: {method: 'GET', params: {val: 'article'}}, //distributionkeys/article
        deleteDistributionKey: {method: 'DELETE'}, //distributionkeys/{id}
        getDistributionKey: {method: 'GET'}, //distributionkeys/{id}
        updateDistributionKey: {method: 'PUT'}, //distributionkeys/{id}
    })
}]);
rkcApp.factory('LinkCampaigns', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/campaigns/link/:year', {}, {
        linkCampaigns: {method: 'POST'}, //campaigns/link/{year}
    })
}]);
rkcApp.factory('Campaigns', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/campaigns/:val', {}, {
        getCampaigns: {method: 'GET', isArray: true}, //campaigns/
        postCampaigns: {method: 'POST'}, //campaigns/
        deleteCampaign: {method: 'DELETE'}, //campaigns/{id}
        getCampaign: {method: 'GET'}, //campaigns/{id}
        updateCampaign: {method: 'PUT'}, //campaigns/{id}
    })
}]);
rkcApp.factory('User', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/user/:subdir', {}, {
        login: {method: 'POST', params: {subdir: 'authenticate'}}, //user/authenticate
        logout: {method: 'POST', params: {subdir: 'logout'}}, //user/logout
        changePassword: {method: 'POST', params: {subdir: 'passwordUser'}}, //user/passwordUser
        getUser: {method: 'GET'}, //user
        getAvatar: {method: 'GET', params: {subdir: 'avatar'}} //user/avatar
    })
}]);
rkcApp.factory('Users', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/users/data/:action/:username', {}, {
        getUsers: {method: 'GET', isArray: true}, //users/data
        getUserDetails: {method: 'GET'}, //users/data/{username}
        getPrinters: {method: 'GET', params: {action: 'printers'}}, //users/data
        updatePrinters: {method: 'PUT', params: {action: 'printers'}}, //users/data
        updateUser: {method: 'PUT'}, //users/data/{username}
        createUser: {method: 'POST'}, //users/data
        deleteUser: {method: 'DELETE'}, //users/data/{username}
    })
}]);
rkcApp.factory('UserAuthorities', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/users/:username/authorities', {}, {
        updateAuthorities: {method: 'PUT', isArray: true}, //users/{username}/authorities
    })
}]);
rkcApp.factory('Authorities', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/authorities', {}, {
        getAuthorities: {method: 'GET', isArray: true}, //authorities
    })
}]);
rkcApp.factory('Orders', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/customerOrders/:orderNumber/:action/:isReadyForConfirmation', {}, {
        search: {method: 'GET', params: {action: 'search'}}, //customerOrders/search
        canDeliverEarlierOrders: {method: 'GET', params: {action: 'canDeliverEarlierOrders'}}, //customerOrders/canDeliverEarlierOrders
        cantDeliverOrders: {method: 'GET', params: {action: 'cantDeliverOrders'}}, //customerOrders/cantDeliverOrders
        splitOrders: {method: 'GET', params: {action: 'splitOrders'}}, //customerOrders/splitOrders
        unconfirmedOrders: {method: 'GET', params: {action: 'unconfirmedOrders'}}, //customerOrders/unconfirmedOrders
        getOrderDetails: {method: 'GET'}, //customerOrders/{orderNo}
        confirmOrder: {method: 'PATCH', params: {action: 'confirm'}}, //customerOrders/{orderNo}/confirm
        sendConfirmationMail: {method: 'PATCH', params: {action: 'sendConfirmationMail'}}, //customerOrders/{orderNo}/sendConfirmationMail
        setConfirmationDate: {method: 'PATCH', params: {action: 'confirmationDate'}}, //customerOrders/{orderNo}/confirmationDate
        readyForConfirmation: {method: 'PATCH', params: {action: 'readyForConfirmation'}}, //customerOrders/{orderNo}/readyForConfirmation/{isReadyForConfirmation}
    })
}]);
rkcApp.factory('Articles', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/articleOverview/:action', {}, {
        search: {method: 'GET', params: {action: 'search'}}, //articleDemands/search
    })
}]);
rkcApp.factory('ArticleProfiles', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/articleDemands/:articleId/profile', {}, {
        findArticle: {method: 'GET',}, ///articleDemands/{articleId}/profile
    })
}]);
rkcApp.factory('ArticleDemands', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/articleDemands/analyze', {}, {
        trigger: {method: 'POST'}, //articleDemands/analyze
    })
}]);
rkcApp.factory('OrderLines', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/customerOrderLines/:lineId/:action', {}, {
        getAbberations: {method: 'GET', params: {action: 'abberationOrderLines'}}, //customerOrderLines/abberationOrderLines
        search: {method: 'GET', params: {action: 'search'}}, //customerOrderLines/search
        getUnconfirmed: {method: 'GET', params: {action: 'unconfirmedOrderLines'}}, //customerOrderLines/unconfirmedOrderLines
        split: {method: 'POST', params: {action: 'split'}}, //customerOrderLines/{lineId}/split
        setConfirmationDate: {method: 'PATCH', params: {action: 'confirmationDate'}}, //customerOrderLines/{lineId}/confirmationDate
    })
}]);

// WMS

rkcApp.factory('Items', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/wms/items/:itemId/:action', {}, {
        getItems: {method: 'GET'}, //wms/items
        getItem: {method: 'GET'}, //wms/items/{itemId}
        getItemBalance: {method: 'GET', isArray: true, params: {action: 'balance'}}, //wms/items/{itemId}/balance
        getItemTransactions: {method: 'GET', params: {action: 'transactions'}}, //wms/items/{itemId}/transactions
    })
}]);
rkcApp.factory('Locations', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/wms/locations/:locationId/:action', {}, {
        getLocations: {method: 'GET'}, //wms/locations
        getLocation: {method: 'GET'}, //wms/locations/{locationId}
        deleteLocation: {method: 'DELETE'}, //wms/locations/{locationId}
        updateLocation: {method: 'PUT'}, //wms/locations/{locationId}
        getLocationBalance: {method: 'GET', isArray: true, params: {action: 'balance'}}, //wms/locations/{locationId}/balance
        getLocationTransactions: {method: 'GET', params: {action: 'transactions'}}, //wms/locations/{locationId}/transactions
    })
}]);
rkcApp.factory('Zones', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/wms/zones/', {}, {
        getZones: {isArray: true, method: 'GET'}, //wms/zones
    })
}]);

rkcApp.factory('PickListUsers', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/wms/users/', {}, {
        getPicklistUsers: {isArray: true, method: 'GET'}, //wms/users
    })
}]);

rkcApp.factory('Shipments', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/wms/shipments/:action/:shipmentId', {}, {
        getShipments: {method: 'GET'}, //wms/shipments
        createShipment: {method: 'POST'}, //wms/shipments
        updateShipment: {method: 'PUT'}, //wms/shipments/{shipmentId}
        deleteShipment: {method: 'DELETE'}, //wms/shipments/{shipmentId},
        getShipmentLines: {isArray: true, method: 'GET', params: {action: 'details'}} //wms/shipments/details
    })
}]);
rkcApp.factory('ShipmentDefaults', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/wms/shipments/default/:date/:locationName', {}, {
        setDefaults: {method: 'POST'}, //wms/shipments/default/{date}
    })
}]);
rkcApp.factory('PickStatus', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/wms/pickstatus/:action', {}, {
        getPickStatusBookings: {method: 'GET', isArray: false, params: {action: 'bookingsList'}}, //wms/pickstatus/bookingsList,
        getPickStatusLoadingDocument: {method: 'GET', params: {action: 'loadingdocument'}}, //wms/pickstatus/loadingdocument
        getPickStatusOrders: {method: 'GET', isArray: true, params: {action: 'orders'}}, //wms/pickstatus/orders
        getPickStatusShipments: {method: 'GET', isArray: true, params: {action: 'shipments'}}, //wms/pickstatus/shipments
        getPickStatusTotal: {method: 'GET', params: {action: 'total'}}, //wms/pickstatus/totalList
    })
}]);
rkcApp.factory('Picklists', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/wms/picklists/:picklistId/:action', {}, {
        postPicklists: {method: 'POST'}, //wms/picklists
        putPicklist: {method: 'PUT', params: {action: 'assign'}}, //wms/picklists/{picklistId}/assigndeletePicklist: {method:'DELETE'} //wms/picklists/{picklistId}tdele
    })
}]);
rkcApp.factory('Imports', ['$resource', function ($resource) {
    return $resource('/ws/import/:action', {}, {
        importForecast: {method: 'GET', params: {action: 'forecast'}}, //ws/import/forecast
        importStock: {method: 'GET', params: {action: 'stock'}}, //ws/import/stock
        importCampaignCodes: {method: 'GET', params: {action: 'campaign'}}, //ws/import/campaign
    })
}]);
rkcApp.factory('Erp', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/wms/erp/sessions/:id/:rand', {}, {
        getSessions: {method: 'GET'}, //wms/erp/sessions
        getTransactions: {method: 'GET', isArray: true, params: {rand: 'transactions'}}, //wms/erp/sessions/{id}/transactions
        updateTransaction: {method: 'PUT'}, //wms/erp/sessions/{id}
    })
}]);

rkcApp.factory('WmsFifo', ['$resource', 'apiUrl', function ($resource, apiUrl) {
    return $resource(apiUrl + '/wms/fifo/:id', {}, {
        getFifo: {method: 'GET'}, //wms/fifo
        postFifo: {method: 'POST'}, //wms/fifo
        deleteFifo: {method: 'DELETE'}, //wms/fifo/{id}
        putFifo: {method: 'PUT'}, //wms/fifo/{id}
    })
}]);



/** WEBPACK FOOTER **
 ** ./src/app/services/restServices.ts
 **/